/**
 * un élément de liste de la popUp d'édition des filterKey.
 * Contient soit un FdvVO soit un ChronocodeVO
 */
export class PivotFilterKeyItemObj {
  public vo: any; // le vo source, soit FdvVO soit ChronocodeVO
  public code: string = ''; // la valeur du freedatavalue / chronocode
  public label: string = ''; // le libellé correspondant au code

  public fullStr: string = '';

  constructor(vo: any) {
    this.vo = vo;
    this.code = vo.code;
    this.label = vo.trsLabel;
    this.fullStr = this.label + ' (' + this.code + ')';
  }
}
